import { createStore, applyMiddleware, compose, combineReducers } from "redux";
//import reducers from "../reducers";
import ThemeOptions from "../reducers/ThemeOptions";
import auth from "../reducers/auth/authReducer";
import user from "../reducers/user/userReducer";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


export default function configureStore() {
  return createStore(
    combineReducers({
      ThemeOptions,
      auth,
      user,
    }),
    composeEnhancers(applyMiddleware(thunk))
  );
}

